module.exports = __webpack_public_path__ + "img/icon_portrait_report_image_8.69ee5e8c.png";